import React from "react";
import Modal from "react-bootstrap/Modal";
import { BorderButton } from "../BorderButton/BorderButton";
import { FillButton } from "../FillButton/FillButton";
import "./popupComponent.css";

export const PopupComponent = ({
  show,
  title,
  message,
  icon,
  fillButtonText,
  fillButtonClick,
}) => {
  return (
    <div>
      <Modal show={show} centered>
        <Modal.Header>
          <img src={icon} alt="icon" />
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <FillButton text={fillButtonText} onClick={fillButtonClick} />
        </Modal.Footer>
      </Modal>
    </div>
  );
};
